var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSpeakerOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_30123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5186 7.87531C17.5184 7.71036 17.4716 7.54884 17.3837 7.40929C17.2958 7.26973 17.1703 7.15782 17.0216 7.08641C16.8729 7.015 16.7071 6.98699 16.5432 7.0056C16.3793 7.0242 16.224 7.08867 16.0951 7.19159L11.9525 10.505H7.87655C7.64408 10.505 7.42112 10.5973 7.25674 10.7617C7.09235 10.9261 7 11.149 7 11.3815V18.3939C7 18.6264 7.09235 18.8494 7.25674 19.0137C7.42112 19.1781 7.64408 19.2705 7.87655 19.2705H11.9525L16.0951 22.5839C16.224 22.6868 16.3793 22.7512 16.5432 22.7699C16.7071 22.7885 16.8729 22.7604 17.0216 22.689C17.1703 22.6176 17.2958 22.5057 17.3837 22.3662C17.4716 22.2266 17.5184 22.0651 17.5186 21.9001V7.87531ZM22.8218 14.8877C22.8231 15.9239 22.6197 16.9502 22.2232 17.9075C21.8266 18.8648 21.2448 19.7343 20.5112 20.4661L19.2717 19.2267C19.8423 18.6575 20.2948 17.9811 20.6032 17.2365C20.9116 16.4919 21.0698 15.6937 21.0687 14.8877C21.0697 14.0818 20.9115 13.2836 20.6031 12.539C20.2947 11.7944 19.8423 11.118 19.2717 10.5488L20.5112 9.30934C21.2448 10.0411 21.8266 10.9106 22.2232 11.868C22.6197 12.8253 22.8231 13.8515 22.8218 14.8877Z",
    fill: "#616266"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_30123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpeakerOn);
export default __webpack_public_path__ + "static/media/ic-speaker-on.f43a918dcdfbe089ace64f2ae63e7aa8.svg";
export { ForwardRef as ReactComponent };